import React, { Component } from 'react';
import AppData from '../../Model/AppData';

let _firstTimerProcessTimer = true
class PendingPaymentTimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countdown_time: -1,
            countdown_timeStr: "0:00",
        };
        this.countDownTimer = null
        this.buttonRef = React.createRef()
    }
    componentDidMount() {
        this.updateCountDownTimer()
    }
    componentWillReceiveProps() {
        this.updateCountDownTimer()
    }
    componentDidUpdate() {
        $('#btnCountdown').popover()
        if (!AppData.data) {
            return
        }
        if (this.buttonRef.current) {
            if (!this.countDownTimer) {
                this.setTimer()
            }
        }
        else {
            this.clearTimer()
        }
        if (!window.timerHintShown && this.buttonRef.current != null) {
            // On every page load, only auto show this popover once
            window.timerHintShown = true
            setTimeout(() => this.buttonRef.current && this.buttonRef.current.click(), 1500);
        }
    }
    setTimer = () => {
        this.countDownTimer = setInterval(this.updateCountDownTimer.bind(this), 1000)
    }
    clearTimer = () => {
        if (this.countDownTimer !== null) {
            clearInterval(this.countDownTimer)
            this.countDownTimer = null
        }
    }
    componentWillUnmount() {
        this.clearTimer()
    }


    // Update the time remaining to Confirm All Orders
    updateCountDownTimer() {
        if (!AppData.data || !(AppData.data.state.table_session && AppData.data.state.table_session.pickup_confirmed_at)) {
            return
        }

        if (AppData.data.state.table_session.bill_id) {
            // Paid, no need show timer
            this.setState({
                countdown_time: -1
            }, this.clearTimer)
            return;
        }

        const bufferTime = pending_payment_timeout * 60
        const pickupConfirmedAt = moment(AppData.data.state.table_session.pickup_confirmed_at)
        const deadlineTime = pickupConfirmedAt.add(bufferTime, 'second')
        const now = moment()
        let diffSecond = deadlineTime.diff(now) / 1000
        const minuteAndSecond = moment.utc(diffSecond * 1000).format('mm:ss');
        if (diffSecond < 0) {
            if (_firstTimerProcessTimer) {
                _firstTimerProcessTimer = false
                $.ajax({
                    url     : `/table_sessions/${window.table_session_id}/payment_timeout`,
                    type    : "post",
                })
            }
            else if (!this.waitingApiResponse) {
                this.clearTimer()
                this.waitingApiResponse = true
                // Do not fire multiple times
                $.ajax({
                    url     : `/table_sessions/${window.table_session_id}/payment_timeout`,
                    type    : "post",
                }).always(() => {
                    setTimeout(() => {
                        this.waitingApiResponse = false
                    }, 1500);
                })
            }
            
            diffSecond = diffSecond < 0 ? 0 : diffSecond
            this.setState({
                countdown_time: 0,
                countdown_timeStr: "0.00"
            })
        }
        else {
            this.setState({
                countdown_time: diffSecond,
                countdown_timeStr: minuteAndSecond
            })
        }
    }
    render() {
        // <Popover/> has additional right margin added
        // from app_extra.css
        return (
            this.state.countdown_time > 0 && <button id="btnCountdown" ref={this.buttonRef} className="navbar-btn btn btn-sm btn-default pull-right"
                data-toggle="popover" data-content={lang.complete_payment_before_timeout}
                data-placement="bottom"
            >
                {this.state.countdown_timeStr}
            </button>
        )
    }
}

export default PendingPaymentTimer;